import React from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { ScrapingTaskCreate } from '../hooks/useScrapingTasks';
import TaskForm, { TaskFormSubmitData } from './TaskForm';

interface CreateTaskDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (submitData: TaskFormSubmitData) => void;
  definitions: any[];
  loading?: boolean;
}

const CreateTaskDialog: React.FC<CreateTaskDialogProps> = ({
  open,
  onClose,
  onSubmit,
  definitions,
  loading = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth keepMounted>
      <DialogTitle>Create New Scraping Task</DialogTitle>
      <TaskForm
        mode="create"
        definitions={definitions}
        loading={loading}
        onCancel={onClose}
        onSubmit={submitData => {
          // Backend may still expect a name; synthesize one from brand/product/keywords
          const d = submitData.taskData as any;
          const autoName = [d.brand_name, d.product_name, d.keywords_text]
            .filter(Boolean)
            .join(' ')
            .trim();
          const taskData = { ...d, ...(autoName ? { name: autoName } : {}) } as ScrapingTaskCreate;

          onSubmit({
            ...submitData,
            taskData,
          });
        }}
      />
    </Dialog>
  );
};

export default CreateTaskDialog;
